Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingPrimaryInfo1425476910",
  {"root":"OfferingPrimaryInfo1425476910--root","actionContainer":"OfferingPrimaryInfo1425476910--actionContainer","secondaryDetails":"OfferingPrimaryInfo1425476910--secondaryDetails","scheduleInfoContainer":"OfferingPrimaryInfo1425476910--scheduleInfoContainer","left-aligned":"OfferingPrimaryInfo1425476910--left-aligned","center-aligned":"OfferingPrimaryInfo1425476910--center-aligned","right-aligned":"OfferingPrimaryInfo1425476910--right-aligned"},
  "",
  3,
  "OfferingPrimaryInfo1425476910"
);

